import * as React from "react";
import {
  Drawer,
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

export default function EditPeakSeasonDrawer({
  openModal,
  handleModalClose,
  selectedRow,
  form,
  handleChange,
  handleDateChange,
  EditPeakSeasonDetails,
  cities,
  error,
}) {
  let rentalType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.rentalTypes;  
  delete rentalType?.inverted;

  return (
    <Drawer
      anchor="bottom"
      open={!!openModal}
      onClose={handleModalClose}
      PaperProps={{
        sx: {
          height: "85vh",
          borderTopLeftRadius: 20,
          borderTopRightRadius: 20,
          overflow: "hidden",
        },
      }}
    >
      {/* Header */}
      <Box className="flex items-center justify-between px-6 py-4 border-b">
        <h2 className="text-lg font-semibold">
          Edit Peak Season - ID - {selectedRow?.id}
        </h2>
        <IconButton onClick={handleModalClose}>
          <CloseIcon />
        </IconButton>
      </Box>

      {/* Content */}
      <Box className="p-6 overflow-y-auto h-full">
        <div className="space-y-6">
          <div className="grid grid-cols-5 gap-4">
            <FormControl fullWidth>
              <InputLabel id="rental-type-label">Rental Type</InputLabel>
              <Select
                labelId="rental-type-label"
                value={form.forRentalType}
                onChange={(e) => handleChange("forRentalType", e.target.value)}
                label="rental-type"
              >
                {rentalType &&
                  Object.entries(rentalType).map(([key, value]) => (
                    <MenuItem key={key} value={key}>
                      {value}
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Name"
              required
              value={form.name}
              onChange={(e) => handleChange("name", e.target.value)}
            />

            <TextField
              fullWidth
              type="number"
              label="Peak Rental Charges"
              value={form.peakRentalCharges}
              onChange={(e) =>
                handleChange("peakRentalCharges", e.target.value)
              }
            />

            {/* City */}
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-600">
                City
              </label>
              <select
                value={form.cityId}
                onChange={(e) => handleChange("cityId", e.target.value)}
                className="w-full h-[42px] rounded-md border border-gray-300 
                 px-3 pt-1 text-sm bg-white
                 focus:outline-none focus:border-blue-500
                 focus:ring-1 focus:ring-blue-500"
              >
                <option value="" disabled>
                  Select City
                </option>
                {cities &&
                  Object.entries(cities).map(([key, value]) => (
                    <option key={key} value={key}>
                      {value}
                    </option>
                  ))}
              </select>
            </div>

            {/* Status */}
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-600">
                Status
              </label>
              <select
                value={form.isActive}
                onChange={(e) =>
                  handleChange("isActive", e.target.value === "true")
                }
                className="w-full h-[42px] rounded-md border border-gray-300 
                 px-3 pt-1 text-sm bg-white
                 focus:outline-none focus:border-blue-500
                 focus:ring-1 focus:ring-blue-500"
              >
                <option value="true">Active</option>
                <option value="false">Inactive</option>
              </select>
            </div>

            {/* Price Status */}
            <div className="relative">
              <label className="absolute -top-2 left-3 bg-white px-1 text-xs text-gray-600">
                Price Status
              </label>
              <select
                value={form.isPriceDrop}
                onChange={(e) =>
                  handleChange("isPriceDrop", e.target.value === "true")
                }
                className="w-full h-[42px] rounded-md border border-gray-300 
                 px-3 pt-1 text-sm bg-white
                 focus:outline-none focus:border-blue-500
                 focus:ring-1 focus:ring-blue-500"
              >
                <option value="false">Increased</option>
                <option value="true">Decreased</option>
              </select>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-4">
            <TextField
              fullWidth
              type="date"
              label="Start Date"
              value={form.startDate ? form.startDate.split("T")[0] : ""}
              onChange={(e) => handleDateChange("startDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
            />

            <TextField
              fullWidth
              type="date"
              label="End Date"
              value={form.endDate ? form.endDate.split("T")[0] : ""}
              onChange={(e) => handleDateChange("endDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          {/* Action Button */}
          <div className="flex justify-center mt-10">
            <button
              onClick={EditPeakSeasonDetails}
              className="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-8 py-3 rounded-xl border border-slate-500 text-white font-medium"
            >
              Update
            </button>
          </div>

          {error && <p className="text-red-600 text-center mt-6">{error}</p>}
        </div>
      </Box>
    </Drawer>
  );
}
